export default __webpack_public_path__ + "static/DINosaurKU-Medium-3a9757580be9a2b10158dcaef9323159.woff2";